import React from "react";
import { withRouter } from 'react-router-dom';
import { getQueryStringParams } from "sharedUtils/navUtils";
import RakutenCommissionRawData from './RakutenCommissionRawData';
import AvantLinkCommissionRawData from './AvantLinkCommissionRawData';
import ImpactCommissionRawData from './ImpactCommissionRawData';
import CJCommissionRawData from './CjCommissionRawData';
import PartnerizeCommissionRawData from './PartnerizeCommissionRawData';
import AwinCommissionRawData from './AwinCommissionRawData';
import AscendCommissionRawData from "./AscendCommissionRawData";
import AmazonCommissionRawData from "./AmazonCommissionRawData";
import ShareASaleCommissionRawData from "./ShareASaleCommissionRawData";
import FlexoffersCommissionRawData from "./FlexoffersCommissionRawData";
import DigiDipCommissionRawData from "./DigiDipCommissionRawData";

class AffiliateCommissionRawData extends React.Component {

    componentDidMount = async () => {
        let scrollOptions = {
            left: 0,
            top: 0,
            behavior: 'auto'
        }
    }

    renderAffiliateComponent = () => {
        const { affiliateProgramManager } = this.props;

        switch (affiliateProgramManager.name) {
            case "CJAffiliate":
                return <CJCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Rakuten":
                return <RakutenCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Ascend":
                return <AscendCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Awin":
                return <AwinCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "AvantLink":
                return <AvantLinkCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Impact":
                return <ImpactCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Partnerize":
                return <PartnerizeCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "ShareASale":
                return <ShareASaleCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Amazon":
                return <AmazonCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "Flexoffers":
                return <FlexoffersCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser} startDate={this.props.startDate} endDate={this.props.endDate} />
            case "DigiDip":
                return <DigiDipCommissionRawData affiliateProgramManager={this.props.affiliateProgramManager} loggedInUser={this.props.loggedInUser}  startDate={this.props.startDate} endDate={this.props.endDate}/>
            default:
                return <h1>Unknown Affiliate Program</h1>;
        }
    }

    render() {
        return (
            <>
                {this.renderAffiliateComponent()}
            </>
        )
    }
}

export default withRouter(AffiliateCommissionRawData);
